<template>
    <h-listbox v-model="selectedOption"
        as="div">
        <!-- eslint-disable-next-line vuejs-accessibility/no-static-element-interactions -->
        <div ref="triggerNode"
            @click="updatePopper()"
            @keyup="updatePopper()">
            <h-listbox-button class="group flex items-center outline-none
            focus-visible:rounded-2xs focus-visible:outline-2 focus-visible:outline-white
            focus-visible:ring-4 focus-visible:ring-blue-600">
                <span class="group-hover:underline">{{ t('filter-order') }}</span>

                <span v-if="selectedOption"
                    class="text-gray-500">
                    : {{ selectedOption.title }}
                </span>

                <v-icon icon="chevron-down"
                    class="text-xl"></v-icon>
            </h-listbox-button>
        </div>

        <div ref="popperNode"
            class="z-30">
            <transition enter-active-class="transition duration-150"
                :enter-from-class="`opacity-0 ${placement === 'top' ? 'translate-y-2' : '-translate-y-2'}`"
                enter-to-class="opacity-100"
                leave-active-class="transition duration-150"
                leave-from-class="opacity-100"
                :leave-to-class="`opacity-0 ${placement === 'top' ? 'translate-y-2' : '-translate-y-2'}`"
            >
                <h-listbox-options class="space-y-xs rounded-sm bg-white py-sm pl-md pr-lg
                    text-sm shadow-xl outline-none  ">
                    <h-listbox-option v-for="option in options"
                        v-slot="{ active, selected }"
                        :key="option.value"
                        :value="option"
                        as="template">
                        <li class="cursor-pointer hover:text-red-500
                            "
                            :class="{
                                'text-gray-500': active || selected,
                                'rounded-2xs text-red-500 outline-2 ring-2 ring-blue-600': active,
                            }">
                            {{ option.title }}
                        </li>
                    </h-listbox-option>
                </h-listbox-options>
            </transition>
        </div>
    </h-listbox>
</template>

<script setup lang="ts">
import type { DropdownOption } from '~~/types';

const properties = defineProps<{
    modelValue?: string | number | null
    options: DropdownOption[]
}>();

const emit = defineEmits<{
    (event: 'update:modelValue', value: string | number | undefined): void
}>();

const { t } = useI18n();

const triggerNode = ref<HTMLDivElement>();
const popperNode = ref<HTMLDivElement>();

const { placement, updatePopper } = usePopper(
    triggerNode,
    popperNode,
    'left',
);

const selectedOption = computed({
    get() {
        return properties.options.find((option) => option.value === properties.modelValue);
    },
    set(option?: DropdownOption) {
        emit('update:modelValue', option?.value || undefined);
    },
});
</script>
